import React from "react";

const BackgroundVideo = () => {
  return (
    // <div className="video-container-">
    //   <iframe
    //     src="https://www.youtube.com/embed/0NBnaIOZBLI?autoplay=1&mute=1&controls=0&rel=0&modestbranding=1&loop=1&playlist=0NBnaIOZBLI"
    //     frameBorder="0"
    //     allow="autoplay; fullscreen"
    //     allowFullScreen
    //     title="Background Video"
    //     style={{
    //       width: "100%",
    //       height: "100vh",
    //       pointerEvents: "none", 
    //       objectFit: "cover"
    //     }}
    //   ></iframe>
    // </div>
    <div className="video-bg">
  <iframe
    src="https://www.youtube.com/embed/0NBnaIOZBLI?autoplay=1&mute=1&controls=0&rel=0&modestbranding=1&loop=1&playlist=0NBnaIOZBLI"
    title="Background Video"
    frameBorder="0"
    allow="autoplay; fullscreen"
    allowFullScreen
  ></iframe>

  {/* <div className="content">

    <h1>My Section Content</h1>
  </div> */}
</div>

  );
};

export default BackgroundVideo;